// extracted by mini-css-extract-plugin
export default {"list":"Positions__list___3LTp5"};